import { useCallback, useEffect, useState } from 'react';

import OffersListV2 from './OffersListV2';
import PageContent from '../../global/PageContent';
import { getGenericError } from '../../utils/errors';
import { getSleekOffers } from '../../utils/service';
import MarketingBannerV2 from '../../global/MarketingBannerV2';
import { BROWSER_EXTENSION_URL } from '../../config/externalURL';
import { ROUTE_REWARDS_V2 } from '../../config/routes';
import LaptopPromosImage from '../../images/laptop-promos.png';

import './OffersV2.scss';

const OffersV2 = () => {
  const [listData, setListData] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState('');

  const loadOffers = useCallback(async () => {
    setIsLoading(true);

    const {
      data,
      error: offersError,
    } = await getSleekOffers();

    if (offersError) {
      setListData([]);
      setError(offersError.message ?? getGenericError());
      setIsLoading(false);
      return;
    }

    setListData(data);
    setIsLoading(false);
  }, []);

  useEffect(() => {
    loadOffers();
  }, []);

  return (
    <PageContent
      title="Shop and earn"
      subtitle="Earn more TrashieCash™ by shopping with our extension."
      isLoading={isLoading}
      error={error}
      className="OffersV2"
      backButtonText="GO TO THE DASHBOARD"
      parentUrl={ROUTE_REWARDS_V2}
    >
      <MarketingBannerV2
        title="Earn more"
        description="Earn TrashieCash™ with the Chrome Extension"
        ctaLabel="Add to chrome"
        ctaURL={BROWSER_EXTENSION_URL}
        backgroundImage={LaptopPromosImage}
      />
      {(listData.length && <OffersListV2 offersList={listData} isDashBoard />) || (
        <span className="Ofers__noData">
          No offers available at the moment
        </span>
      )}
    </PageContent>
  );
};

export default OffersV2;
